// import React from 'react';
// // import SvgIcon from 'react-native-svg-icon';
// import svgs2 from './svgs2'; // point to your svgs.js wherever that may be
// // const SvgImage = props => <SvgIcon {...props} svgs={svgs} />;

// const SvgImage2 = props => <SvgIcon {...props} svgs={svgs2} />;
// // export default
// export default SvgImage2;

import React from "react";
// import SvgIcon from 'react-native-svg-icon';
import Svg from "../Icons/svgs2"; // point to your svgs.js wherever that may be
import "./index.css";

function SvgImage2(props) {
  const { name, classname, height, width, color, onClick } = props;

  return (
    <div >
      <div style={{ marginLeft: "5px" }}>
        <Svg
          icon={name}
          classname={classname}
          height={height}
          width={width}
          color={color}
          onClick={onClick}
        />
      </div>
    </div>
  );
}

export default SvgImage2;
